export const COUPONS: { [key: string]: number } = {
  discount_1_usd_off_onetime: 1,
  discount_1_eur_off_onetime: 1,
  discount_2_usd_off_onetime: 2,
  discount_2_eur_off_onetime: 2,
  discount_20_usd_off_onetime: 20,
  discount_20_eur_off_onetime: 20,
  discount_24_usd_off_onetime: 24,
  discount_24_eur_off_onetime: 24,
  discount_30_usd_off_onetime: 30,
  discount_30_eur_off_onetime: 30,
  discount_36_usd_off_onetime: 36,
  discount_36_eur_off_onetime: 36,
  discount_45_usd_off_onetime: 45,
  discount_45_eur_off_onetime: 45,
  discount_90_brl_off_onetime: 90,
  discount_102_brl_off_onetime: 102,
  discount_186213_inr_off_onetime: 1862.13,
  discount_186212_inr_off_onetime: 1862.12,
  discount_1714_gbp_off_onetime: 17.14,
  discount_1715_gbp_off_onetime: 17.15,
  discount_7366_pln_off_onetime: 73.66,
  discount_1500_usd_off_onetime: 15,
  discount_7000000_cop_off_onetime: 70000,
  discount_2900_cad_off_onetime: 29,
  discount_3000_cad_off_onetime: 30,
  discount_2600_aud_off_onetime: 26,
  discount_149_zar_off_onetime: 149,
  discount_164_zar_off_onetime: 164,
};
